export const getColor = (slug: string) => {
  return {
    innerWrapper: 'p-0 &:hover:border-content1-200 [&>button]:bg-primary',
    trigger: `after:hidden border-${slug} hover:border-${slug} !px-[12px]`,
    popoverContent: 'rounded-medium bg-content1-200',
    selectorIcon: `h-[18px] w-[30px] text-${slug}`,
  }
}
